import { render, staticRenderFns } from "./CreateEmailEvent.vue?vue&type=template&id=846c0ff4"
import script from "./CreateEmailEvent.vue?vue&type=script&lang=js"
export * from "./CreateEmailEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports